import { axios } from '@/utils/request'
const api = "/Newness"
export default {
  NewnessList: (parameter) => {
    return axios({
      url: `${api}/NewnessList`,
      method: 'post',
      data: parameter
    })
  },
  deleteNewness: (parameter) => {
    return axios({
      url: `${api}/deleteNewness`,
      method: 'post',
      data: parameter
    })
  },
  SaveNewness: (parameter) => {
    return axios({
      url: `${api}/SaveNewness`,
      method: 'post',
      data: parameter
    })
  },
  AddNewness: (parameter) => {
    return axios({
      url: `${api}/AddNewness`,
      method: 'post',
      data: parameter
    })
  },
  FindNewness: (parameter) => {
    return axios({
      url: `${api}/FindNewness`,
      method: 'post',
      data: parameter
    })
  },

}